<template>
    <div class="cover d-flex align-items-center justify-content-center">
        <div class="card bg-white col-lg-8 col-xl-4">
            <div class="card-body p-4">
                <form @submit.prevent="validateBeforeSubmit" class="">
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="closeLoginForm">
                        <span aria-hidden="true">&times;</span>
                    </button>
                    <h3 class="uc mb-3">Welcome Back {{name}}!</h3>
                    <p class="light mb-3">It looks like we may already have your information on file, please enter the last four digits of your <abbr title="Social Security Number">SSN</abbr> and your zipcode and we'll quickly pull up your details for a super fast loan submission!</p>
                    <div class="row">
                        <div class="col-lg-10">
                            <CleaveInput
                                label="Last 4 digits of your SSN"
                                id="ssnLast4"
                                name="ssnLast4"
                                type="tel"
                                maxlength="4"
                                autocomplete="off"
                                v-model="ssnLast4"
                                v-validate="{ required: true, regex: /^([0-9]{4})$/ }"

                                :exval="validationAttempt"
                                :cleaveoptions="masks.ssnLast4"

                                extracss="dont-mark"

                                errormsg="This is a required field"
                                :error="errors.first('ssnLast4')"
                            />
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-lg-10">
                            <CleaveInput
                                label="What's your zipcode?"
                                id="zipcodeR"
                                name="zipcodeR"
                                maxlength="5"
                                type="tel"
                                v-model="zipcode"
                                :cleaveoptions="masks.zipcode"

                                extracss="dont-mark"

                                v-validate="{ required: true, regex: /^[0-9]{5}$/ }"
                                :exval="validationAttempt"
                                :error="errors.first('zipcode')" 
                            />
                        </div>
                        </div>
  
                    <div v-if="errorMessage" class="alert alert-danger p14">
                        Unfortunately we were unable to retrieve your record. <router-link to="/registration/1">Click Here to submit a new application</router-link>.
                    </div>
                
                    <div class="my-3 d-flex align-items-center">
                        <button class="btn btn-cta btn-red uc" id="form-submit">{{ this.sending ? 'Sending...' : 'Continue' }}</button>
                        <div>
                            <transition name="slide">
                                <span class="some-errors" v-if="(errors.items.length != 0 && validationAttempt)">You have some errors</span>
                            </transition>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    </div>
    
</template>

<script>
import CleaveInput from '@/components/form/CleaveInput.vue';

import axios from 'axios';
import { mapGetters, mapActions } from "vuex";

export default {
    name: 'HomeLoginForm',
    components:{
        CleaveInput,
    },
    props: ['name'],
    data() {
	  return {
            ssnLast4: '',
            zipcode: '',
            validationAttempt: false,
            sending: false,
            errorMessage: false,
            masks: {
                ssnLast4: { numericOnly: true, blocks: [4] },
                zipcode: { numericOnly: true, blocks: [5] },
            },
		}
    },
    methods: {
        ...mapActions(['closeLoginForm', 'verifyAgent']),
        validateBeforeSubmit(){
            this.validationAttempt = true;
            this.sending = true;
			this.$validator.validate().then((result) => {
        		if (result) {
					this.verifyAgent({zipcode: this.zipcode, ssnLast4: this.ssnLast4}).then(response => {
                        if(response === true){
                            this.$router.push({ path: 'registration/returning' });
                        } else {
                            this.errorMessage = true;    
                        }
                    }).catch(err => {
                        this.errorMessage = true;
                        console.log("Error:", err);
                    }).finally(() => {
                        this.sending = false;
                        return;
                    });
				} else {
                    this.sending = false;
                }
      		});
        },
    }
}
</script>

<style>

</style>
